/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  rebateProgramLabel,
  quarterLabel,
  AtrAccountsRecLabel,
  selectRebateProgramLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  AllQtrAccRecColumns,
  QtrAccRecColumns,
  rebateProgramListColumns,
} from '../tablehead';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ActionDropDownComp, { NameTooltipComp } from '../ActionDropdownComp';
import {
  getAccRecNDCAllDetail,
  allAccRecNDCData,
  selectedRebatePgm,
  selectedRebateName,
} from './store/actions';
import { ndcDetail } from '../AccRecNDCDetailAll/store/actions';
import {
  goToArSummaryAccRecNDCAll,
  goToArSummaryQtrAccountSingle,
} from '../ARCommonFunctions';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommonModal from '../ARCommonModal';
import { getSingleAccRecQtr } from '../ARSummaryByQtr/store/actions';
import * as actiontype from '../ARSummaryByQtr/store/actiontypes';
import {
  qtrAccRecFieldValues,
  dispatchQARBalanceDue,
  dispatchQAROveridden,
  dispatchQARPaidInFull,
} from '../QtrAccountsRec/store/actions';
import RedTextRenderComp from '../RedTextRenderComp';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const QtrAccountsRecAll = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [qtrAccRecTableData, setQtrAccRecTableData] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const [errorPopup, setErrorPopup] = React.useState(false);
  const [selectedRebateRow, setSelectedRebateRow] = React.useState([]);
  const [colDefs, setColDefs] = React.useState(QtrAccRecColumns);
  const [pinned, setPinned] = React.useState([]);
  const ar_smry_all_qtr = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.ar_smry_all_qtr
  );
  const getAllQuarterValue = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.getAllQuarterValue
  );
  const getAllAccRecNDCList = useSelector(
    (state) => state?.sharedState?.QtrAccountsRecAllReducer?.getAllAccRecNDCList
  );
  const acc_rec_fld = useSelector(
    (state) =>
      state?.sharedState?.QtrAccountsRecAllReducer?.getAccRecFieldvalues
  );
  const { rebate_list } = useSelector(
    (state) => state?.sharedState?.AccountRecReducer
  );
  const ar_smry_single_qtr_main = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrReducer?.ar_smry_single_qtr_main
  );
  const rebate_pgm_name = useSelector(
    (state) => state?.sharedState?.QtrAccountsRecAllReducer?.rebate_pgm_name
  );
  const rebate_pgm_code = useSelector(
    (state) => state?.sharedState?.QtrAccountsRecAllReducer?.rebate_pgm_code
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  // get account rec single quarter values from redux
  React.useEffect(() => {
    if (ar_smry_single_qtr_main && ar_smry_single_qtr_main.status === '001') {
      if (ar_smry_single_qtr_main?.quarterListInfo?.quarterList?.length) {
        const fieldObj = {
          pgmInfo: rebate_pgm_name,
          pgmCd: rebate_pgm_code,
          qtrInfo: acc_rec_fld?.qtrInfo,
          uraInfo: acc_rec_fld?.uraInfo,
        };
         let qtrAccRecFieldData = {
        [rebate_pgm_code]: fieldObj,
      };
        dispatch(qtrAccRecFieldValues(qtrAccRecFieldData));
        goToArSummaryQtrAccountSingle(
          props.history,
          selectedRebateRow[0]?.rebateProgramCd,
          dispatch
        );
      } else {
        setErrorPopup(true);
        setLoad(false);
      }
      dispatch({
        type: actiontype.AR_SMRY_FOR_QTR_SINGLE,
        payload: null,
      });
    }
  }, [ar_smry_single_qtr_main]);
  // get all NDC detail list and redirect NDC detail all page
  React.useEffect(() => {
    if (getAllAccRecNDCList && getAllAccRecNDCList.status === '001') {
      goToArSummaryAccRecNDCAll(props.history, dispatch);
      dispatch(allAccRecNDCData([]));
    }
  }, [getAllAccRecNDCList]);
  // redirect Go to account receivable NDC Details page
  const handleGoToAccRecNDCDetail = (row) => {
    if (row) {
      setLoad(true);
      const payload = {
        mfgId: row.mfgId,
        startQuarter: getAllQuarterValue,
        aiUseOfficialURA: acc_rec_fld.uraInfo === 'Official' ? 1 : 0,
      };
      dispatch(getAccRecNDCAllDetail(payload));
      dispatch(ndcDetail({ ...row, ...acc_rec_fld, getAllQuarterValue }));
    }
  };
  // select rebate program list function
  const selectRebateProgramList = (row) => {
    if (row) {
      // setShowRebateProgramList(true);
      setSelectedRebateRow([row]);
      const { rebateProgramCd } = row;
      const rebateProgramName = `${row.rebateProgramCd} | ${row.shortDescr}`;
      dispatch(selectedRebatePgm(rebateProgramCd));
      dispatch(selectedRebateName(rebateProgramName));
      setLoad(true);
      const payload = {
        rebateProgram: row.rebateProgramCd,
        quarter: getAllQuarterValue,
        useOfficialURA: acc_rec_fld?.uraInfo === 'Official' ? 1 : 0,
      };
      dispatch(getSingleAccRecQtr(payload));
        if (UserDefaultValues) {
          if (UserDefaultValues?.dispBalanceDueInvInd != 0) {
            dispatch(
              dispatchQARBalanceDue({
                [payload.rebateProgram]: true,
              })
            );
          } else {
            dispatch(
              dispatchQARBalanceDue({
                [payload.rebateProgram]: false,
              })
            );
          }
          if (UserDefaultValues?.dispOverriddenInvInd != 0) {
            dispatch(
              dispatchQAROveridden({
                [payload.rebateProgram]: true,
              })
            );
          } else {
            dispatch(
              dispatchQAROveridden({
                [payload.rebateProgram]: false,
              })
            );
          }
          if (UserDefaultValues?.dispPaidInFullInvInd != 0) {
            dispatch(
              dispatchQARPaidInFull({
                [payload.rebateProgram]: true,
              })
            );
          } else {
            dispatch(
              dispatchQARPaidInFull({
                [payload.rebateProgram]: false,
              })
            );
          }
        } else {
          dispatch(
            dispatchQARBalanceDue({
              [payload.rebateProgram]: true,
            })
          );
          dispatch(
            dispatchQAROveridden({
              [payload.rebateProgram]: true,
            })
          );
          dispatch(
            dispatchQARPaidInFull({
              [payload.rebateProgram]: false,
            })
          );
        }
    }
  };
  React.useEffect(() => {
    const columns = QtrAccRecColumns.filter(
      (obj) =>
        ['Invoice Number', 'Invoice Status', 'Invoice Date'].indexOf(
          obj.headerName
        ) === -1
    );
    setColDefs(columns);
  }, []);
  // on row selected
  // const onRowSelect = (val) => {
  //   let [row] = val.api.getSelectedRows();
  //   setSelectedRebateRow([row]);
  //   let rebateProgramCd = [row][0].rebateProgramCd;
  //   let rebateProgramName = [row][0].name;
  //   dispatch(selectedRebatePgm(rebateProgramCd));
  //   dispatch(selectedRebateName(rebateProgramName));
  // };
  // redirect particular selected rebate list row function
  // const redirectRebateList = () => {
  //   if (selectedRebateRow.length != 0) {
  //     setLoad(true);
  //     let payload = {
  //       rebateProgram: selectedRebateRow[0]?.rebateProgramCd,
  //       quarter: getAllQuarterValue,
  //       useOfficialURA: acc_rec_fld?.uraInfo === 'Official' ? 1 : 0,
  //     };
  //     dispatch(getSingleAccRecQtr(payload));
  //   }
  // };
  // ag-grid frame work component
  const frameworkComponents = {
    ActionCellRender: (cellInfo) => {
      return (
        // <div className="tdCell dib icon-btn-group" data-testid="action-column">
        //   <Dropdown className="icon-dropdown-container">
        //     <Dropdown.Toggle
        //       className="icon-dropdown export_wrap"
        //       aria-label="export"
        //     >
        //       <OverlayTrigger
        //         placement="bottom"
        //         overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
        //       >
        //         <SVGComponent iconName="Icon-export1" />
        //       </OverlayTrigger>
        //     </Dropdown.Toggle>
        //     <Dropdown.Menu className="export_dropdown">
        //       <Dropdown.Item
        //         role="button"
        //         onClick={() => selectRebateProgramList(cellInfo?.data)}
        //       >
        //         Select Rebate Program
        //       </Dropdown.Item>
        //       <Dropdown.Item
        //         role="button"
        //         onClick={() => handleGoToAccRecNDCDetail(cellInfo?.data)}
        //       >
        //         Go To Accounts Receivable NDC Detail
        //       </Dropdown.Item>
        //     </Dropdown.Menu>
        //   </Dropdown>
        // </div>
        <ActionDropDownComp
          data={cellInfo}
          loadfn={setLoad}
          displayBy="qtrAccRec"
          selectPgm
          selectedRebate={selectRebateProgramList}
          // extraData={qtr_val}
          handleGoToAccRecNDCDetail={handleGoToAccRecNDCDetail}
        />
      );
    },
    RedTextRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    FullNameRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return <NameTooltipComp data={cellInfo} />;
    },
    invoiceDateRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return cellInfo.value;
      }
      return null;
    },
  };
  // ongrid ready for table component
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (filterApply) {
      const data = [
        {
          currBal: sum('currBal'),
          offsetDue: sum('offsetDue'),
          baseStateAmtDue: sum('baseStateAmtDue'),
          interestDue: sum('interestDue'),
          totalDue: sum('totalDue'),
          offsetPaidAmt: sum('offsetPaidAmt'),
          baseStatePaidAmount: sum('baseStatePaidAmount'),
          interestPaid: sum('interestPaid'),
          currInvAmt: sum('currInvAmt'),
          currentRoa: sum('currentRoa'),
          baseStateRebateAmount: sum('baseStateRebateAmount'),
          origInvoiceAmt: sum('origInvoiceAmt'),
          adjustmentAmount: sum('adjustmentAmount'),
          disputeCount: sum('disputeCount'),
          disputeAmt: sum('disputeAmt'),
          amtPaid: sum('amtPaid'),
          famPlanAmt: sum('famPlanAmt'),
          fedAmt: sum('fedAmt'),
          reimbAmt: sum('reimbAmt'),
          stateAmt: sum('stateAmt'),
          actions: 'hide',
          mfgName: 'Total:',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    } else {
      const data = [
        {
          currBal: ar_smry_all_qtr?.quarterListInfo?.totalCurrBal,
          offsetDue: ar_smry_all_qtr?.quarterListInfo?.totalOffsetDue,
          baseStateAmtDue:
            ar_smry_all_qtr?.quarterListInfo?.totalBaseStateAmtDue,
          interestDue: ar_smry_all_qtr?.quarterListInfo?.totalInterestDue,
          totalDue: ar_smry_all_qtr?.quarterListInfo?.finalTotalDue,
          offsetPaidAmt: ar_smry_all_qtr?.quarterListInfo?.totalOffsetPaidAmt,
          baseStatePaidAmount:
            ar_smry_all_qtr?.quarterListInfo?.totalBaseStatePaidAmount,
          interestPaid: ar_smry_all_qtr?.quarterListInfo?.totalInterestPaid,
          currInvAmt: ar_smry_all_qtr?.quarterListInfo?.totalCurrInvAmt,
          currentRoa: ar_smry_all_qtr?.quarterListInfo?.totalCurrentRoa,
          baseStateRebateAmount:
            ar_smry_all_qtr?.quarterListInfo?.totalBaseStateRebateAmount,
          origInvoiceAmt: ar_smry_all_qtr?.quarterListInfo?.totalOrigInvoiceAmt,
          adjustmentAmount:
            ar_smry_all_qtr?.quarterListInfo?.totalAdjustmentAmount,
          disputeCount: ar_smry_all_qtr?.quarterListInfo?.totalDisputeCount,
          disputeAmt: ar_smry_all_qtr?.quarterListInfo?.totalDisputeAmt,
          amtPaid: ar_smry_all_qtr?.quarterListInfo?.totalAmtPaid,
          famPlanAmt: ar_smry_all_qtr?.quarterListInfo?.totalFamPlanAmt,
          fedAmt: ar_smry_all_qtr?.quarterListInfo?.totalFedAmt,
          reimbAmt: ar_smry_all_qtr?.quarterListInfo?.totalReimbAmt,
          stateAmt: ar_smry_all_qtr?.quarterListInfo?.totalStateAmt,
          actions: 'hide',
          mfgName: 'Total:',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    }
  }, [filterApply, filteredRows]);
  React.useEffect(() => {
    if (ar_smry_all_qtr && ar_smry_all_qtr.quarterListInfo?.quarterList) {
      setQtrAccRecTableData(ar_smry_all_qtr.quarterListInfo?.quarterList);
    }
  }, [ar_smry_all_qtr]);

  let firstInfo = `Rebate Program: All | All Rebate Programs`;
  let secondInfo = `Quarter: ${getAllQuarterValue}`;

  return (
    <div className="tabs-container ARScreen" data-testid="QtrAccountsRecAll">
      <Spinner load={load} />
      <CustomSeparator
        parent1="Research"
        parent2="Quarterly Accounts Receivable"
      />
      {!fullScreenView && (
        <div className="row">
          <div className="col-12 frr-mt-9">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <legend arai-hidden="true" className="d-none" />
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value="All | All Rebate Programs"
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="quarter"
                      label={quarterLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={getAllQuarterValue}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={colDefs}
            rowData={qtrAccRecTableData || []}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            pinnedBottomRowData={
              qtrAccRecTableData?.length ? pinned : undefined
            }
            info={{ firstInfo, secondInfo }}
            fileName={AtrAccountsRecLabel}
            hideColumnsInPdf={['actions']}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            onFilterData={false}
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
      <CommonModal
        open={errorPopup}
        viewAction
        viewHeader
        modalTitle="Quarterly Accounts Receivable"
        className="dialog-420"
        okTitle="Ok"
        onOk={() => setErrorPopup(false)}
        onClose={() => setErrorPopup(false)}
        childrenComponent="No outstanding receivables exists for the selected quarter."
      />
    </div>
  );
};

export default QtrAccountsRecAll;
